import { API_CALL } from 'actions/actionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_ACTIVE_CUSTOM_RULES } from 'actions/apiActionConstants'
import requestLoyaltyActiveCustomRules from 'api/loyalty/requestLoyaltyActiveCustomRules'

function fetchLoyaltyActiveCustomRules(): AppAction {
  return (dispatch, getState) => {
    const state = getState()

    if (
      state.loyalty.activeCustomRules ||
      state.loyalty.fetchingActiveCustomRules ||
      state.loyalty.activeCustomRulesError
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_ACTIVE_CUSTOM_RULES,
      request: () => requestLoyaltyActiveCustomRules(),
    })
  }
}

export default fetchLoyaltyActiveCustomRules
